import React, { useContext, useState } from 'react'

import { Link } from 'tools/Link'
//import notifier from 'tools/Notify'
import ProgressiveComponents, { packComponent } from 'tools/ProgressiveComponents'
import { cleanPath } from 'utils/string'

import GetCard from 'hub/GetStarted/GetCard'
import { AddOrg, GetOrgAddress } from 'hub/GetStarted/GetOrg'
import {
  GetStartedContext,
  GetStartedProvider,
  doesOrgHaveAddress
} from 'hub/GetStarted/reducer'
import paths from 'hub/paths'
import GlobalContext from 'reducer/global'

const COMPONENTS = [
  packComponent(GetOrgAddress, (state) => Boolean(state.orgId)),
  packComponent(GetCard, (state) => doesOrgHaveAddress(state.org)),
  packComponent(EditLink, (state) => state.card != null, 'Settings')
]

function Create() {
  return (
    <div className="pv2 mt3">
      <GetStartedProvider>
        <InnerCreate />
      </GetStartedProvider>
    </div>
  )
}

function InnerCreate() {
  const [open, setOpen] = useState(false)
  const [state] = useContext(GetStartedContext)
  const [{ user }] = useContext(GlobalContext)
  const first = user.orgMemberships.length === 0

  const newOrg = state?.orgId != null

  if (!open && !newOrg) {
    return (
      <button className="clear f3 medium" onClick={() => setOpen(true)}>
        <i className="fas fa-plus mr2" />
        Add Organization
      </button>
    )
  }

  console.log({ state })
  if (open && !newOrg) {
    return (
      <AddOrg onClose={() => setOpen(false)} first={first}>
        {state.org.name} Address
      </AddOrg>
    )
  }

  return (
    <>
      <ProgressiveComponents
        components={COMPONENTS}
        className="gv3 mv5"
        state={state}
        borderClass="mb5 mt4"
      />
    </>
  )
}

function EditLink() {
  const [{ orgId }] = useContext(GetStartedContext)
  const url = cleanPath(paths.public.org, orgId, 'settings')
  return (
    <Link to={url}>
      Edit Org <i className="pl1 fa-solid fa-arrow-up-right-from-square" />{' '}
    </Link>
  )
}

export default Create
